import { render, staticRenderFns } from "./EtransactAirtimePurchasePage.vue?vue&type=template&id=5c8d88e1&scoped=true"
import script from "./EtransactAirtimePurchasePage.vue?vue&type=script&lang=js"
export * from "./EtransactAirtimePurchasePage.vue?vue&type=script&lang=js"
import style0 from "./EtransactAirtimePurchasePage.vue?vue&type=style&index=0&id=5c8d88e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8d88e1",
  null
  
)

export default component.exports